import styled, { css } from 'styled-components';

import { Colors } from 'environment';
import { getTypographyCSS } from 'components/UI/Typography';

interface WrapperProps {
	small?: boolean;
	meridian?: boolean;
	noLeftMargins?: boolean;
	disabled?: boolean;
	readOnly?: boolean;
}
export const Wrapper = styled.div<WrapperProps>`
	${({ small, meridian, noLeftMargins, disabled, readOnly }) => css`
		display: flex;
		justify-content: space-between;

		margin-top: ${(small || meridian) && 0.4}rem;
		margin-left: ${small || meridian || noLeftMargins ? '0' : '0.8rem'};

		height: ${small ? 2.64 : 4}rem;

		${meridian &&
		css`
			> :nth-child(n) {
				width: calc(50% - 0.2rem);
			}
		`}

		${readOnly &&
		css`
			pointer-events: none;

			${TimeSelect} {
				cursor: unset;
				border-color: ${Colors.text.disabled};
				background-color: ${Colors.background.disabled};

				input {
					background-color: ${Colors.background.disabled};

					::placeholder,
					::-webkit-input-placeholder {
						background-color: ${Colors.background.disabled};
					}
				}
			}
		`};

		${disabled &&
		css`
			pointer-events: none;

			${TimeSelect} {
				cursor: unset;
				border-color: ${Colors.text.disabled};
				background-color: ${Colors.background.disabled};

				input {
					color: ${Colors.text.disabled};
					background-color: ${Colors.background.disabled};

					/* TODO: this is a quick fix for crash in https://ledidi.atlassian.net/browse/PRJCTS-6827  */
					/* ::placeholder,
					::-webkit-input-placeholder {
						background-color: ${Colors.text.disabled};
					} */
				}

				.time-input__toggle-icon,
				.time-input__hour-divider {
					color: ${Colors.text.disabled};
				}
			}
		`};
	`}

	/* TODO: make this global */
	.creatable-select-small {
		.select-container {
			min-height: 2.4rem;
		}

		.select__control {
			min-height: 2.4rem;
		}

		.select__value-container {
			height: 2.4rem;
			min-height: 2.4rem;
			align-items: center;

			> :last-child {
				height: 2rem;
				margin: 0;
				padding: 0;

				.select__input[style] {
					display: flex !important;
				}

				input,
				.select__input {
					height: 2rem;
				}
			}
		}

		.select__single-value {
			${getTypographyCSS(t => t.Caption)}

			color: ${Colors.text.main};
			height: 2rem;
			margin: 0;
		}

		.select__placeholder {
			${getTypographyCSS(t => t.Caption)}

			color: ${Colors.text.disabled};
			margin: 0;
			padding: 0;
		}

		input[style] {
			${getTypographyCSS(t => t.Caption)}

			color: ${Colors.text.main};
		}

		input {
			${getTypographyCSS(t => t.Caption)}

			color: ${Colors.text.main};
			font-size: 1.2rem !important;
		}
	}
`;

interface TimeSelectProps {
	open: boolean;
	meridian?: boolean;
	noLeftMargins?: boolean;
	error?: boolean;
}
export const TimeSelect = styled.div<TimeSelectProps>`
	display: flex;
	position: relative;
	cursor: pointer;
	padding: 0 0.8rem;
	border-radius: 0.4rem;
	border: solid 0.12rem
		${({ open, error }) =>
			open ? Colors.primary.normal : error ? Colors.text.error : Colors.text.disabled};
	background-color: ${Colors.white};
	transition: 0.1s;
	width: ${({ meridian, noLeftMargins }) =>
		noLeftMargins ? '12rem' : meridian ? '100%' : '9.6rem'};
`;

export const Input = styled.input`
	/* TYPOGRAPHY SETTER */
	${getTypographyCSS(t => t.Paragraph)}

	/* REMOVE AUTOFIL BACKGROUND COLOR */
	:-webkit-autofill,
	:-webkit-autofill:hover,
	:-webkit-autofill:focus,
	:-webkit-autofill:active {
		box-shadow: 0 0 0px 100rem white inset !important;
	}

	height: 100%;
	border: none;
	outline: none;
	padding: 0;
	color: ${Colors.text.main};

	::placeholder,
	::-webkit-input-placeholder {
		color: ${Colors.text.caption};
	}
`;
